import React from "react";

export default function GrowthLoopDisclaimer() {
  return ( 
    <div className="space-y-2 text-sm text-gray-200">
        <h1 className="text-sm lg:text-lg font-semibold text-cyan-400">⚠️ Important Disclaimer</h1>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-2">
            <div className="bg-gray-900 border border-gray-500 rounded-xl p-2">
                <p className="text-gray-100 text-xs lg:text-sm">
                👀 <span className="font-medium text-cyan-200">
                    GrowthLoop is a non-clinical, non-diagnostic observational framework
                </span>{" "}
                designed to support early identification of patterns related to attention
                regulation, executive functioning, emotional balance, self-belief, and
                learning readiness in children.
                </p>
            </div>

            <div className="bg-gray-900 border border-gray-500 rounded-xl p-2">
                <p className="text-gray-100 text-xs lg:text-sm">
                🩺 GrowthLoop{" "}
                <span className="font-medium text-cyan-200">does not diagnose</span> ADHD,
                learning disabilities, behavioral disorders, or any medical,
                psychological, or developmental condition. It is{" "}
                <span className="font-medium text-cyan-200">not a substitute</span> for
                professional evaluation.
                </p>
            </div>

            <div className="bg-gray-900 border border-gray-500 rounded-xl p-2">
                <p className="text-gray-100 text-xs lg:text-sm">
                🧩 Observations from parents, educators, and professionals are{" "}
                <span className="font-medium text-cyan-200">
                    contextual, subjective, and situational
                </span>
                . Visual scores reflect{" "}
                <span className="font-medium text-cyan-200">
                    patterns over time
                </span>
                , not clinical thresholds or labels.
                </p>
            </div>

            <div className="bg-gray-900 border border-gray-500 rounded-xl p-2">
                <p className="text-gray-100 text-xs lg:text-sm">
                📊 Any summaries, heatmaps, or AI-generated insights are meant to support{" "}
                <span className="font-medium text-cyan-200">
                    reflection, communication, and early planning
                </span>
                . They must always be interpreted within the child’s age, culture,
                environment, and lived experience.
                </p>
            </div>

            <div className="bg-gray-900 border border-gray-500 rounded-xl p-2 col-span-2 lg:col-span-4">
                <p className="text-gray-100 text-xs lg:text-sm">
                🤝 If concerns persist, intensify, or interfere with daily life,
                caregivers are encouraged to consult{" "}
                <span className="font-medium text-cyan-200">
                    qualified medical, mental health, or educational professionals
                </span>
                .
                </p>
            </div>
        </div>

        <div className="bg-black border border-cyan-500 rounded-xl p-2 text-center">
            <p className="text-gray-100 text-xs lg:text-sm">
                🌱 GrowthLoop stands for{" "}
                <span className="font-medium">support before labeling</span>,{" "}
                <span className="font-medium">structure before stigma</span>, and{" "}
                <span className="font-medium">growth before judgment</span>.
            </p>
        </div>
    </div>
  );
}